import { useDark } from '@vueuse/core'

import type { Directive } from 'vue'

export type StoreAwayState = 'idle' | 'loading' | 'success' | 'error'

const isDarkMode = useDark()

function updateAnimationClasses(element: HTMLElement, state: StoreAwayState): void {
  // Remove all store-away animation classes
  element.classList.remove(
    'animate-store-away-start',
    'animate-store-away-return-success',
    'animate-store-away-return-error',
    'animate-store-away-return-error-dark',
  )

  // Add the appropriate class based on state
  switch (state) {
    case 'loading': {
      element.classList.add('animate-store-away-start')
      break
    }
    case 'success': {
      element.classList.add('animate-store-away-return-success')
      break
    }
    case 'error': {
      if (isDarkMode.value) {
        element.classList.add('animate-store-away-return-error-dark')
      } else {
        element.classList.add('animate-store-away-return-error')
      }
      break
    }
  }
}

export const storeAway: Directive<HTMLElement, StoreAwayState> = {
  mounted(element, binding) {
    // Handle initial state
    updateAnimationClasses(element, binding.value)
  },

  updated(element, binding) {
    const newState = binding.value
    const oldState = binding.oldValue

    if (newState === oldState) {
      return
    }

    updateAnimationClasses(element, newState)
  },
}
